import gql from "graphql-tag";
import { taskFileTypeDef } from "../definitions/task-file-type-def";

const removeTaskFileMutation = gql`
  mutation removeTaskFile (
  $taskFileId: String!
  ) {
    taskFile{
      remove(input: {
        id: $taskFileId
      }) {
        output {
          ${taskFileTypeDef}
        }
      }
    }
  }`;

export default removeTaskFileMutation;
